import CreateExitTicketView from "@features/tools/view/exit-tickets-view/create-exit-ticket-view";

const CreateExitTicket = () => {
  return <CreateExitTicketView />;
};

export default CreateExitTicket;
